var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#100;stroke-miterlimit:10;stroke-width:0.25px;}")),React.createElement("title",{"key":1},"Asset 8"),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":2},React.createElement("g",{"id":"Layer_2-2","data-name":"Layer 2"},[React.createElement("line",{"className":"cls-1","x1":"3.16","x2":"3.16","y2":"49","key":0}),React.createElement("path",{"className":"cls-1","d":"M.1,45.17A47.63,47.63,0,0,0,3.16,49l3.07-3.83","key":1})]))]);
}

ArrowDown.defaultProps = {"viewBox":"0 0 6.32 49.19"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
